<template>
  <div>
    <div class="container-fluid bg-white mt-3 p-5 colunm-border-top colunm-border-bottom">
      <!-- <h1 class="text-uppercase font-basetheme font-kanit text-center my-3">Client</h1> -->
      <div class="row d-flex justify-content-around">
        <img src="@/assets/img/home/client/brave.png" height="100" class="mx-2" alt />
        <img src="@/assets/img/home/client/gsb.jpg" height="100" class="mx-2" alt />
        <img src="@/assets/img/home/client/scb.jpg" height="100" class="mx-2" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>